import React from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import EmailIcon from "../assets/images/email-us.svg";
import UserNameIcon from "../assets/images/username.svg";
import User from "../assets/images/user.svg";
import { useLocation } from "react-router-dom";
import PasswordInput from "../component/PasswordInput";
import { CREATE_ACCOUNT } from "../api/constants";
import Swal from "sweetalert2";


function CreateAccount() {
  const location = useLocation();
  const [email, setEmail] = React.useState(location.state?.email || '');
  const [password, setPassword] = React.useState('');
  const [first_name, setFirstName] = React.useState('');
  const [last_name, setLastName] = React.useState('');
  const [username, setUsername] = React.useState('');
  const [error, setError] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check required fields
    if (!email || !password || !first_name || !last_name || !username) {
      setError("All fields are required");
      return;
    }

    // Validate email
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Invalid email format");
      return;
    }

    // Validate password (min 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char)
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password)) {
      setError(
        "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character"
      );
      return;
    }

    setError("");
    // Call your API to create account
    fetch(CREATE_ACCOUNT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
        first_name,
        last_name,
        username,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.status) {
          //reset form
          setEmail('');
          setPassword('');
          setFirstName('');
          setLastName('');
          setUsername('');
          Swal.fire({
            icon: 'success',
            title: 'Account created successfully',
            text: data.message
          });
        } else {
          setError(data.errors);
        }
      })
      .catch((error) => {
        console.error("Error creating account:", error);
        setError("Error creating account");
      });
  };


  return (
    <div className="login-sign-main common-padding" >
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img width={140} src={Logo} alt="" />
            <h3>Create your account</h3>
          </div>

          <Form>
            <Form.Group className="from-group mb-3">
              <Form.Control type="text" placeholder="First Name" value={first_name} onChange={(e) => setFirstName(e.target.value)} />
              <img src={User} alt="" />
            </Form.Group>
            <Form.Group className="from-group mb-3">
              <Form.Control type="text" placeholder="Last Name" value={last_name} onChange={(e) => setLastName(e.target.value)} />
              <img src={User} alt="" />
            </Form.Group>
            <Form.Group className="from-group mb-3">
              <Form.Control type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
              <img src={UserNameIcon} alt="" />
            </Form.Group>
            <Form.Group className="from-group mb-3">
              <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} />
              <img src={EmailIcon} alt="" />
            </Form.Group>
            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} />
            <Button className="custom-bttn style-3 w-100 mt-3" onClick={handleSubmit}>
              Create Account
            </Button>
            <p className="text-danger">
              {error}
            </p>
            <p>
              New to Jambobay?{" "}
              <a href="/sign-in">
                Sign in
              </a>
            </p>
            {/* <div className="text-center or-div m-0 min-h-auto"></div>
            <p className="mb-0">
              <a href="/terms">
                Or send a secure code to your email
              </a>
            </p> */}
          </Form>
        </Card>
      </Container>
    </div>
  );
}

export default CreateAccount;
